import { AddCircleOutline } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getAllMenu } from '../api/CRUD/getAllMenu';
import { getLiveMenu } from '../api/CRUD/getLiveMenu';
import CreateMenu from '../components/create';
import EditMenu from '../components/edit';
import ViewMenu from '../components/view';
import {
    dataFields_menu_group,
    HeadCells_menu_group,
    dataFields_menu_live,
    HeadCells_menu_live,
} from '../constant';
import { Menu } from '../type';
import { useNotificationStore } from '@/stores/notifications';
import { useDisclosure } from '@/hooks/useDisclosure';
import { ContentLayout } from '@/components/Layout';
import TableWithSort from '@/components/Elements/Table/TableWithSort';
import CustomTable from '@/components/Elements/Table/CustomTable';
import { Confirm } from '@/components/Elements/Dialog/Confirm';
import { Button, Dialog, Spinner } from '@/components/Elements';
//import { HeadCells } from '@/features/users/constant';

import '../styles/styles.css';
import { axios } from '@/lib/axios';
import AssignProducts from '../components/assignProducts';
import EditProduct from '../components/editProduct';

export const Menus = () => {
    const { close, open, isOpen } = useDisclosure();
    const { addNotification } = useNotificationStore();

    const [searchVal, setSearchVal] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [menu, setMenu] = useState<Menu[]>([]);
    const [livemenu, setLiveMenu] = useState<Menu[]>([]);
    const [createMenu, setCreateMenu] = useState<boolean>(false);
    const [copyMenu, setCopyMenu] = useState<Menu | null>(null);
    const [editMenu, setEditMenu] = useState<Menu | null>(null);
    const [editProduct, setEditProduct] = useState<Menu | null>(null);
    const [viewMenu, setviewMenu] = useState<Menu | null>(null);
    const [assignProducts, setAssignProducts] = useState<Menu | null>(null);
    const [locationFilter, setLocationFilter] = useState();
    const [checkboxFilter, setCheckboxFilter] = useState<string>('all');
    const [confirmDeactivateMsg, setConfirmDeactivateMsg] = useState<User | null>(null);
    const [confirmActivateMsg, setConfirmActivateMsg] = useState<User | null>(null);
    const [value, setValue] = useState(0);

    const handleChange = (newValue) => {
        const a = parseInt(newValue.target.id);
        setValue(a);
    };

    const handleSearch = (e: any) => {
        setSearchVal(e.target.value);
    };

    async function getMenu() {
        setIsLoading(true);
        const res = await getAllMenu();
        const reslive = await getLiveMenu();
        setMenu(res);

        let resLiveMod = [];

        resLiveMod = reslive.map((item) => {
            const data: any = {
                id: '',
                menu_group_name: '',
                location_name: '',
                activation_time: '',
                expiration_time: '',
                active: '',
                location: '',
                menu_group: '',
            };
            data.id = item.id;
            data.menu_group_name = item.menu_group.menu_group_name;
            data.location_name = item.location.location_name;
            data.activation_time = item.activation_time;
            data.expiration_time = item.expiration_time;
            data.active = 1;
            data.location = item.location;
            data.menu_group = item.menu_group;
            return data;
        });

        setLiveMenu(resLiveMod);
        setIsLoading(false);
    }

    useEffect(() => {
        getMenu();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [close]);

    if (isLoading) {
        return (
            <div className="w-full h-48 flex justify-center items-center">
                <Spinner size="lg" />
            </div>
        );
    }

    if (!menu) return null;

    const filteredMenu = menu?.filter((menu: Menu) => {
        if (searchVal || locationFilter) {
            if (menu?.location_name === locationFilter) {
                return menu;
            } else if (menu?.location_name === locationFilter) {
                return menu;
            }
            if (searchVal) {
                return menu?.name?.toLowerCase()?.includes(searchVal.toLowerCase());
            }
        } else {
            return menu;
        }
    });

    const filteredLiveMenu = livemenu?.filter((livemenu: Menu) => {
        if (searchVal || locationFilter) {
            if (livemenu?.location_name === locationFilter) {
                return menu;
            } else if (livemenu?.location_name === locationFilter) {
                return menu;
            }
            if (searchVal) {
                return livemenu?.name?.toLowerCase()?.includes(searchVal.toLowerCase());
            }
        } else {
            return livemenu;
        }
    });

    const deleteMenu = async (id) => {
        const updateData = {
            id: id,
            active: false,
        };

        const { success, message } = await axios.post(
            `v1/admin/menus/update-menu-groups`,
            updateData
        );
        return { success, message };
    };

    const activateMenu = async (id) => {
        const updateData = {
            id: id,
            active: true,
        };

        const { success, message } = await axios.post(
            `v1/admin/menus/update-menu-groups`,
            updateData
        );
        return { success, message };
    };

    const handleDelete = async (menuData: Menu) => {
        await deleteMenu(menuData.id).then(() => {
            addNotification({
                type: 'success',
                title: 'Menu Deactivated!',
            });
        });
        getMenu();
        setConfirmDeactivateMsg(null);
    };

    const handleActivate = async (menuData: Menu) => {
        await activateMenu(menuData.id).then(() => {
            addNotification({
                type: 'success',
                title: 'Menu Activated!',
            });
        });
        getMenu();
        setConfirmActivateMsg(null);
    };

    const selectedUserAction = ({ action, data }) => {
        switch (action) {
            case 'view':
                setEditMenu(null);
                setviewMenu(data);
                setCreateMenu(false);
                open();
                break;
            case 'edit':
                setviewMenu(null);
                setEditMenu(data);
                setCreateMenu(false);
                open();
                break;
            case 'copy':
                setviewMenu(null);
                setEditMenu(null);
                setCreateMenu(false);
                setCopyMenu(data);
                open();
                break;
            case 'edit-product':
                setviewMenu(null);
                setEditMenu(null);
                setCreateMenu(false);
                setEditProduct(data);
                setCopyMenu(null);
                open();
                break;
            case 'add-user':
                setviewMenu(null);
                setEditMenu(null);
                setCreateMenu(false);
                open();
                break;
            case 'add-invoice':
                setviewMenu(null);
                setEditMenu(null);
                setCreateMenu(false);
                open();
                break;
            case 'assign-products':
                setviewMenu(null);
                setEditMenu(null);
                setCreateMenu(false);
                setAssignProducts(data);
                open();
                break;
            case 'activate':
                setConfirmActivateMsg(data);
                break;
            case 'deactivate':
                setConfirmDeactivateMsg(data);
                break;
            default:
                return null;
        }
    };

    const closeDialog = () => {
        setviewMenu(null);
        setEditMenu(null);
        setCreateMenu(false);
        setAssignProducts(null);
        setCopyMenu(null);
        setEditProduct(null);
        close();
    };

    const LocationOptions = new Set(livemenu?.map((item) => item.location_name));

    function TabPanel(props: any) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index: any) {
        return {
            id: index,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <ContentLayout title="" topNavBarData={{ num: menu.length, title: 'Menus' }}>
            {confirmDeactivateMsg ? (
                <Confirm
                    btnTitle={'Deactivate'}
                    onClose={() => setConfirmDeactivateMsg(null)}
                    onSuccess={() => handleDelete(confirmDeactivateMsg)}
                />
            ) : null}
            {confirmActivateMsg ? (
                <Confirm
                    btnTitle={'Activate'}
                    onClose={() => setConfirmActivateMsg(null)}
                    onSuccess={() => handleActivate(confirmActivateMsg)}
                />
            ) : null}
            <div className="table-header">
                <form>
                    <div className="row">
                        <div className="col-12 col-md-9">
                            <div className="flex">
                                <div className="input-group search">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={searchVal}
                                        onChange={(e) => handleSearch(e)}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <select
                                        className="form-control search-top-menu ml-1 w-auto"
                                        name="location"
                                        value={locationFilter}
                                        onChange={(e) => setLocationFilter(e.target.value)}
                                    >
                                        <option value="">Select Location</option>
                                        {[...LocationOptions]?.map((location_name) => (
                                            <option key={location_name} value={location_name}>
                                                {location_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="checkboxes flex items-center justify-center ml-4 gap-4 pt-2">
                                    <div className="all-bx">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="all"
                                                name="all"
                                                value="All"
                                                checked={checkboxFilter === 'all'}
                                                onChange={() => {
                                                    checkboxFilter !== 'all' &&
                                                        setCheckboxFilter('all');
                                                }}
                                            />
                                            <span>All</span>
                                        </label>
                                    </div>
                                    <div className="all-bx live">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="live"
                                                name="live"
                                                value="Live"
                                                checked={checkboxFilter === 'Live'}
                                                onChange={() => {
                                                    checkboxFilter === 'Live'
                                                        ? setCheckboxFilter('all')
                                                        : setCheckboxFilter('Live');
                                                }}
                                            />
                                            <span>Live</span>
                                        </label>
                                    </div>
                                    <div className="all-bx Draft">
                                        <label className="checkbox">
                                            <input
                                                type="checkbox"
                                                id="Draft"
                                                name="Draft"
                                                value="Draft"
                                                checked={checkboxFilter === 'Draft'}
                                                onChange={() => {
                                                    checkboxFilter === 'Draft'
                                                        ? setCheckboxFilter('all')
                                                        : setCheckboxFilter('Draft');
                                                }}
                                            />
                                            <span>Draft</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-3">
                            <div className="add-btn" style={{ float: 'right' }}>
                                <Button
                                    startIcon={<AddCircleOutline />}
                                    onClick={() => (setCreateMenu(!createMenu), open())}
                                >
                                    Add Menu
                                </Button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 0 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        className="prTabs menu-dash-tabs"
                        style={{ paddingTop: '10px' }}
                    >
                        <Tab
                            label="All Menus"
                            className="left-menu"
                            value={0}
                            {...a11yProps(0)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '6px 0px 0 0',
                                width: '50%',
                                maxWidth: '50%',
                            }}
                        />
                        <Tab
                            label="Live Menus"
                            className="right-menu"
                            value={1}
                            {...a11yProps(1)}
                            style={{
                                border: '1px solid  #c8d4df',
                                borderRadius: '0px 6px 0 0',
                                width: '50%',
                                maxWidth: '50%',
                            }}
                        />
                    </Tabs>
                </Box>

                <TabPanel className="menu-tab-panel" value={value} index={0}>
                    <CustomTable
                        tableData={filteredMenu}
                        headCells={HeadCells_menu_group}
                        dataFields={dataFields_menu_group}
                        selectedUserAction={selectedUserAction}
                        rowOptions={true}
                        optionMenu={['copy', 'activate', 'deactivate']}
                    />
                </TabPanel>
                <TabPanel className="menu-tab-panel" value={value} index={1}>
                    <CustomTable
                        tableData={filteredLiveMenu}
                        headCells={HeadCells_menu_live}
                        dataFields={dataFields_menu_live}
                        selectedUserAction={selectedUserAction}
                        rowOptions={true}
                        optionMenu={['edit']}
                    />
                </TabPanel>
            </Box>

            <Dialog
                isOpen={isOpen}
                onClose={closeDialog}
                paperWidth={assignProducts ? '70%' : '45%'}
            >
                <div className="modals-contents">
                    {createMenu && (
                        <CreateMenu
                            menuData={createMenu}
                            action={'create'}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                            getMenu={getMenu}
                        />
                    )}
                    {editMenu && (
                        <EditMenu
                            menuData={editMenu}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                            getMenu={getMenu}
                        />
                    )}
                    {copyMenu && (
                        <CreateMenu
                            menuData={copyMenu}
                            action={'copy'}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                            getMenu={getMenu}
                        />
                    )}
                    {editProduct && (
                        <EditProduct
                            menuData={editProduct}
                            action={'copy'}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                        />
                    )}
                    {viewMenu && (
                        <ViewMenu
                            menuData={viewMenu}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                        />
                    )}
                    {assignProducts && (
                        <AssignProducts
                            menuData={assignProducts}
                            closeDialog={closeDialog}
                            selectedUserAction={selectedUserAction}
                        />
                    )}
                    {/* {editMenu && <EditMenu posData={editMenu} closeDialog={closeDialog} />} */}
                </div>
            </Dialog>
        </ContentLayout>
    );
};
